/** @format */

import { call, all } from 'redux-saga/effects';
import { userSagas } from './user/user.sagas';
import { flightDataSagas } from './flightData/flightData.sagas';
import { messageSagas } from './message/message.sagas';
import { trueblueFormSagas } from './form-trueblue/from-trueblue.sagas';
import { trueblueAutomationSagas } from './tb-automation/tb-automation.sagas';
import { newHireSagas } from './new-hire/new-hire.sagas';
import { terminationSagas } from './termination/termination.sagas';
import { valetDataSagas } from './valetData/valetData.sagas';
import { pingHandlerSagas } from './ping-handler/ping-handler.sagas';
import { stationChecklistSagas } from './stationChecklist/station-checklist.sagas';
import { newHireEditorSagas } from './new-hire-ref/new-hire-ref.sagas';
import { pairingModelSagas } from './pairing-model/pairing-model.sagas';
import { voucherSagas } from './voucher/voucher.sagas';
import { messageHistorySagas } from './message-history/message-history.sagas';

export default function* rootSaga() {
  yield all([
    call(userSagas),
    call(flightDataSagas),
    call(messageSagas),
    call(trueblueFormSagas),
    call(trueblueAutomationSagas),
    call(newHireSagas),
    call(terminationSagas),
    call(valetDataSagas),
    call(pingHandlerSagas),
    call(stationChecklistSagas),
    call(newHireEditorSagas),
    call(pairingModelSagas),
    call(voucherSagas),
    call(messageHistorySagas),
  ]);
}
